import { Stack } from 'component-library';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Logger } from '@/lib/logs/logger';

import { Card } from './o/Card/Card';
import { useWidgetTitle } from './useWidgetTitle';

type WidgetErrorFallbackProps = {
  name: string;
  type: string;
};

const WidgetErrorFallback = ({ name, type }: WidgetErrorFallbackProps) => {
  const { t } = useTranslation();
  const widgetTitle = useWidgetTitle({ name, type });

  const cardProps = {
    styles: {
      root: 'rounded-3xl p-4',
    },
  };

  return (
    <Card {...cardProps}>
      <Stack spacing={4}>
        {widgetTitle && <span className='typography-body1'>{widgetTitle}</span>}
        <span className='typography-body1 text-text-disabled'>{t('global.widget.error.message')}</span>
      </Stack>
    </Card>
  );
};

export const WidgetErrorBoundary = ({ name, type, children }: WidgetErrorFallbackProps & { children: ReactNode }) => {
  return (
    <ErrorBoundary
      FallbackComponent={(props) => <WidgetErrorFallback {...props} name={name} type={type} />}
      onError={(error, info) => {
        Logger.error(`Widget rendering error (name: ${name}, type: ${type}): ${error} ${info}`);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
